import { CloseButton } from '@mantine/core';
import { useState } from 'react';

import { CommunityFeedItemDto } from 'src/Services/API/generated';

import { CommunityFeedItem } from '../../CommunityFeedItem';

import styles from './MemoryModal.module.scss';
import { Props } from './MemoryModal.props';
import { MemoryModalEdit } from './MemoryModalEdit';
import { MemoryModalPhotos } from './MemoryModalPhotos';

/**
 * The modal that shows the content of a memory.
 * There is two states: viewing and editing/creating.
 */
const MemoryModal = ({
  memory: originalMemory,
  closeModal,
  onMemoryCreated,
  startInEdit,
}: Props) => {
  const [isEdit, setIsEdit] = useState(!!startInEdit);
  const [latestMemory, setLatestMemory] = useState<CommunityFeedItemDto | null>(null);

  const onFinishEditing = (memory: CommunityFeedItemDto) => {
    if (originalMemory) {
      // We just edited a memory
      setIsEdit(false);
      setLatestMemory(memory);
    } else {
      // We just created a new memory.
      onMemoryCreated?.(memory);
    }
  };

  const onCancelEditing = () => {
    setIsEdit(false);

    if (!latestMemory) {
      closeModal?.();
    }
  };

  const memory = latestMemory ?? originalMemory;

  return (
    <div className={styles.container}>
      <div className={styles.exitButton}>
        <CloseButton onClick={closeModal} bg="white" />
      </div>

      {!memory || isEdit ? (
        <MemoryModalEdit
          feedItem={memory}
          onFinish={onFinishEditing}
          onCancel={onCancelEditing}
          onError={() => closeModal?.()}
        />
      ) : (
        <>
          <div className={styles.photos}>
            <MemoryModalPhotos memory={memory} />
          </div>

          <div className={styles.rightColumn}>
            <CommunityFeedItem
              feedItem={memory}
              areCommentsOpenByDefault
              grow
              onBeginEdit={() => setIsEdit(true)}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default MemoryModal;
